import { render } from "./groupHome.vue?vue&type=template&id=652b0376&scoped=true"
import script from "./groupHome.vue?vue&type=script&lang=js"
export * from "./groupHome.vue?vue&type=script&lang=js"

import "./groupHome.vue?vue&type=style&index=0&id=652b0376&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652b0376"]])

export default __exports__